import useOnlineStatus from "../../../common/utils/OnlineStatusProvider";
import Offline from "../../../common/pages/Offline";


import { Container } from "@mui/material";


import "../../../styles/react-confirm-alert.css";
import styles from "../../../styles/checkout.module.css";

/* ------------------------------------------------------------------------- */
const Checkout = () => {
  const isOnline = useOnlineStatus();

  if(isOnline){
    return (
      <Container maxWidth="xxl" className={styles.contentWrap}>

        
          <p>Page Checkout</p>
        
      </Container>
    );
  }else{
    return (<Offline/>)
  }
};

export default Checkout;
